"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var signature_pad_1 = __importDefault(require("signature_pad"));
var FeatureFlag_1 = require("@CommonFrontendBackend/FeatureFlag");
var react_1 = __importDefault(require("react"));
var ESignV3_1 = __importDefault(require("./ESignV3"));
var MountReactComponent_1 = __importDefault(require("@CommonFrontend/MountReactComponent/MountReactComponent"));
var lodash_1 = require("lodash");
var ESign = (function () {
    function ESign(createUi, make, $timeout, acceptData, setErrorMsg, $sce, disclaimer, usingFeature, di) {
        var _this = this;
        this.name = "esignature";
        if (acceptData.esignature == null) {
            acceptData.esignature = "";
        }
        if (acceptData.disclaimerAccepted == null) {
            acceptData.disclaimerAccepted = false;
        }
        var errorMessage = null;
        var usingEsignV3 = !usingFeature(FeatureFlag_1.FeatureFlag.OptOutNewEditor);
        var isUsingAcceptBlockPrintMode = usingFeature(FeatureFlag_1.FeatureFlag.AcceptBlockPrintMode);
        var isPrintMode = isUsingAcceptBlockPrintMode && di.has("isPrintMode") ? di.get("isPrintMode") : false;
        if (usingEsignV3) {
            var scope_1 = null;
            var validate_1;
            var devFill_1;
            var previewAutoFill_1;
            this.ui = (0, MountReactComponent_1.default)(createUi, di)(react_1.default.createElement(ESignV3_1.default, {
                disclaimerText: disclaimer,
                printMode: isPrintMode,
                visualMode: isPrintMode ? "simple" : "standard",
                onChange: function (value) {
                    return $timeout(function () {
                        acceptData.esignature = value.signature;
                        acceptData.signatureMethod = value.method;
                        acceptData.disclaimerAccepted = value.disclaimerAccepted;
                    });
                },
                registerImperativeHandlers: function (handlers) {
                    validate_1 = handlers.validate;
                    devFill_1 = handlers.devFill;
                    previewAutoFill_1 = handlers.previewAutoFill;
                },
            }), {
                $init: function (s) {
                    scope_1 = s;
                },
            });
            this.validate = function () {
                return validate_1();
            };
            this.devFill = function () {
                return $timeout(function () { return devFill_1(acceptData.name); });
            };
            this.previewAutoFill = function () {
                return $timeout(function () { return previewAutoFill_1(acceptData.name); });
            };
        }
        else {
            var isGeneratedSignature_1 = false;
            var onEnd_1 = function () {
                _this.ui.removeErrorMessage();
                acceptData.esignature = _this.ui.signaturePad.toDataURL();
                acceptData.signatureMethod = isGeneratedSignature_1 ? "created" : "drawn";
            };
            this.ui = createUi(require("./ESign.html"), {
                showForm: true,
                showDateStamp: usingEsignV3,
                dateStamp: new Date(Date.now()).toLocaleDateString(),
                disclaimer: $sce.trustAsHtml(disclaimer),
                disclaimerAccepted: acceptData.disclaimerAccepted,
                showDisclaimer: function () {
                    return usingEsignV3;
                },
                onCheck: function () {
                    acceptData.disclaimerAccepted = !acceptData.disclaimerAccepted;
                    _this.ui.disclaimerAccepted = acceptData.disclaimerAccepted;
                },
                isEmpty: function () {
                    if (_this.ui.signaturePad == null) {
                        return true;
                    }
                    return _this.ui.signaturePad.isEmpty();
                },
                clear: function () {
                    _this.ui.signaturePad.clear();
                },
                hasErrorMessage: function () {
                    return errorMessage && this.ui.isEmpty();
                },
                removeErrorMessage: function () {
                    if ((errorMessage === null || errorMessage === void 0 ? void 0 : errorMessage.hide) != null) {
                        errorMessage.hide();
                        errorMessage = null;
                    }
                },
                $init: function (scope) {
                    return scope.$watch("ui.signature", function () {
                        if (_this.ui.signature != null) {
                            var canvas_1 = _this.ui.signature[0];
                            _this.ui.signaturePad = new signature_pad_1.default(canvas_1, {
                                onEnd: onEnd_1,
                            });
                            var resizeCanvas = function () {
                                var data = _this.ui.signaturePad.toData();
                                _this.ui.signaturePad.clear();
                                var ratio = Math.max(window.devicePixelRatio || 1, 1);
                                canvas_1.width = canvas_1.offsetWidth * ratio;
                                canvas_1.height = canvas_1.offsetHeight * ratio;
                                canvas_1.getContext("2d").scale(ratio, ratio);
                                return _this.ui.signaturePad.fromData(data);
                            };
                            window.onresize = resizeCanvas;
                            return resizeCanvas();
                        }
                    });
                },
                allowGenerate: function () {
                    var _a;
                    return ((_a = acceptData.name) === null || _a === void 0 ? void 0 : _a.length) && _this.ui.isEmpty();
                },
                generate: function () {
                    if (!_this.ui.allowGenerate()) {
                        return;
                    }
                    var canvas = _this.ui.signature[0];
                    var canvasContext = canvas.getContext("2d");
                    canvasContext.font = "30px Damion";
                    canvasContext.fillText(acceptData.name, 25, 95);
                    _this.ui.signaturePad.fromDataURL(canvas.toDataURL());
                    isGeneratedSignature_1 = true;
                    return onEnd_1();
                },
            });
            this.validate = function () {
                if (_this.ui.isEmpty()) {
                    errorMessage = setErrorMsg("Please sign to accept the quote.", ".e-sign .draw-input");
                    return false;
                }
                if (usingEsignV3 && (acceptData.disclaimerAccepted === false || (acceptData.disclaimerAccepted.length = 0))) {
                    errorMessage = setErrorMsg("Please indicate that you agree to the terms and conditions to accept the quote", ".disclaimer");
                    return false;
                }
                else {
                    return true;
                }
            };
            this.devFill = this.ui.generate;
            this.previewAutoFill = lodash_1.noop;
        }
    }
    return ESign;
}());
exports.default = ESign;
